import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useFormikForm } from '#/common/hooks';
import { ROUTES } from '#/routes';
import { apiEndpoints, usePostMutation } from '#/services';
import {
    ACCESS_TOKEN,
    LogInValidationSchema,
    REMEMBER_ME_FLAG,
    getLocalStorageItem,
    getSessionStorageItem,
    loginInInitialValues,
    removeLocalStorageItem,
    setLocalStorageItem,
    setSessionStorageItem,
} from '#/utils';

export function useLogIn() {
    const navigate = useNavigate();

    const { mutate: loginCall, isPending: loginLoading } = usePostMutation({
        url: apiEndpoints.LOGIN,
        onSuccess: signInCallSuccess,
    });

    function signInCallSuccess(resp) {
        if (!resp?.access) return;
        const token = resp.access;
        const rememberMe = getLocalStorageItem(REMEMBER_ME_FLAG);
        removeLocalStorageItem(REMEMBER_ME_FLAG);
        if (rememberMe) {
            setLocalStorageItem(ACCESS_TOKEN, token);
        } else {
            setSessionStorageItem(ACCESS_TOKEN, token);
        }

        navigate(ROUTES.HOME);
    }

    const handleLogin = async values => {
        setLocalStorageItem(REMEMBER_ME_FLAG, values?.rememberMe);
        const payLoadData = {
            email: values?.email,
            password: values?.password,
        };
        loginCall({
            payload: payLoadData,
        });
    };

    const navigateToForgot = () => {
        navigate(ROUTES.FORGOT_PASSWORD);
    };

    const {
        handleChange: handleChangeLogin,
        handleSubmit: handleSubmitLogin,
        errors: loginErrors,
        touched: loginTouched,
        values: loginValues,
        setFieldValue: setLoginValues,
    } = useFormikForm(loginInInitialValues, handleLogin, LogInValidationSchema);

    useEffect(() => {
        if (getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN)) {
            navigate(ROUTES.HOME);
        }
    }, []);
    return {
        handleChangeLogin,
        handleSubmitLogin,
        loginErrors,
        loginTouched,
        loginValues,
        setLoginValues,
        loginLoading,
        navigateToForgot,
    };
}
